<template>
  <div class="matrix_layoutMain container" :class="getClassNameContainer">
    <div class="row">
      <div class="col-md-12">
        <appQuantityTable>
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
        <appUploadTable alwaysShow="true"></appUploadTable>
        <div class="matrix_summaryInformation">
          <appFactsheet></appFactsheet>
        </div>
        <appAddToCartButton></appAddToCartButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

export default {};
</script>
